
// `x-charts-vendor/flatqueue` (CommonJS)
// See upstream license: git+https://github.com/mourner/flatqueue/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/flatqueue`
module.exports = require("../lib-vendor/flatqueue/index.js");
